module.exports = __webpack_public_path__ + "media/views/reviews/images/star-empty-9f300758d349e96a49ceafb11711b4f2.svg";